import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import MiniLogo from "@/components/Logo";

export default function Navbar({ view, navigate }) {
  const [open, setOpen] = useState(false);

  const go = (target) => {
    setOpen(false);
    navigate(target);
  };

  return (
    <header
      className="sticky top-0 z-40 border-b border-amber-500/10 bg-[#0C0C0A]/90 backdrop-blur-md"
      data-testid="header-nav"
    >
      <div className="flex items-center justify-between px-5 py-4">
        <button
          type="button"
          onClick={() => go("/")}
          aria-label="Ir para o início"
          data-testid="nav-logo-button"
        >
          <MiniLogo />
        </button>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="p-1 text-amber-200 transition-colors duration-300 hover:text-amber-400"
          aria-label="Abrir menu"
          data-testid="nav-menu-button"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden border-t border-amber-500/10"
            data-testid="nav-menu"
          >
            <button
              type="button"
              onClick={() => go("/")}
              className="block w-full px-6 py-3.5 text-left text-sm tracking-wide text-stone-300 transition-colors duration-300 hover:bg-amber-400/5 hover:text-amber-200"
              data-testid="nav-link-inicio"
            >
              Início
            </button>
            <button
              type="button"
              onClick={() => go("?agendar")}
              className={`block w-full px-6 py-3.5 text-left text-sm tracking-wide transition-colors duration-300 hover:bg-amber-400/5 hover:text-amber-200 ${
                view === "agenda" ? "font-semibold text-amber-300" : "text-stone-300"
              }`}
              data-testid="nav-link-agendar"
            >
              Reservar Horário
            </button>
            <a
              href="https://wa.me/5513981197016"
              target="_blank"
              rel="noopener noreferrer"
              className="block px-6 py-3.5 text-sm font-medium text-[#25D366] transition-colors duration-300 hover:bg-[#25D366]/5"
              data-testid="nav-link-whatsapp"
            >
              WhatsApp
            </a>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
